import { ICreateDeviceState } from './createDeviceContext';
import { CreateDeviceActionTypes, TCreateDeviceAction } from './createDeviceActions';

export const createDeviceReducer = (state: ICreateDeviceState, action: TCreateDeviceAction): ICreateDeviceState => {
	switch (action.type) {
		case CreateDeviceActionTypes.CHANGE_HARDWARE_ID:
			return {
				...state,
				hardwareId: action.payload.hardwareId,
			};
		case CreateDeviceActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case CreateDeviceActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDSelectedRestaurant: null,
				bankSettings: [],
			};
		case CreateDeviceActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case CreateDeviceActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				bankSettings: [],
			};
		case CreateDeviceActionTypes.SET_BANK_SETTINGS:
			return {
				...state,
				bankSettings: action.payload.bankSettings,
			};
		case CreateDeviceActionTypes.ADD_BANK_SETTINGS_BLOCK:
			return {
				...state,
				bankSettings: [...state.bankSettings, action.payload.bankSettings],
			};
		case CreateDeviceActionTypes.SET_FETCHED_RESTAURANT_BANK_SETTINGS:
			return {
				...state,
				fetchedRestaurantBankSettings: action.payload.fetchedRestaurantBankSettings,
			};
		case CreateDeviceActionTypes.SET_TLS_CERTIFICATE_LEVEL:
			return {
				...state,
				tlsCertificateLevel: action.payload.tlsCertificateLevel,
				tlsCertificateName: action.payload.tlsCertificateName,
				tlsCertificateFileId: action.payload.tlsCertificateFileId,
				tlsCertificateFileHash: action.payload.tlsCertificateFileHash,
			};
		case CreateDeviceActionTypes.CHANGE_TLS_CERTIFICATE_NAME:
			return {
				...state,
				tlsCertificateName: action.payload.tlsCertificateName,
			};
		case CreateDeviceActionTypes.SET_TLS_CERTIFICATE_FILE:
			return {
				...state,
				tlsCertificateFileId: action.payload.tlsCertificateFileId,
				tlsCertificateFileHash: action.payload.tlsCertificateFileHash,
			};
		case CreateDeviceActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateDeviceActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateDeviceActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case CreateDeviceActionTypes.RESET_FIELDS:
			return {
				...state,
				hardwareId: '',
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDSelectedRestaurant: null,
				bankSettings: [],
				fetchedRestaurantBankSettings: [],
				tlsCertificateLevel: null,
				tlsCertificateName: null,
				tlsCertificateFileId: '',
				tlsCertificateFileHash: null,
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
